import { Attrs, EventListeners, MinzeElement } from 'minze'
import { Font } from '../../../constants'
import { Callback } from '../../../modules/callback'
import { Locale } from '../../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'searchFilterButton', {
  selectPlaceholder: 'Sélectionnez',
})

Locale.getInstance().registerKeySet('en', 'searchFilterButton', {
  selectPlaceholder: 'Select',
})

export interface LvcSearchFilterButton extends MinzeElement {
  count?: number
  selected?: boolean
  onClear?: string
  onClick?: string
  dataFirstChild?: boolean
  dataLastChild?: boolean
  dataValue?: string
}

export class LvcSearchFilterButton extends MinzeElement {
  attrs: Attrs = [
    'count',
    'selected',
    'on-clear',
    'on-click',
    'preset',
    'data-value',
    ['data-first-child', false],
    ['data-last-child', false],
  ]
  static observedAttributes = ['count', 'selected', 'on-clear', 'on-click', 'data-value']

  onAttributeChange(
    name?: string,
    oldValue?: string | null,
    newValue?: string | null
  ): Promise<void> | void {
    if (name === 'data-value') {
      this.dataValue = newValue ?? ''
    }
  }

  onClearButton(): void {
    Callback.call((this.onClear ?? '') as string)
  }

  onClickButton(): void {
    const button = this.select('.filter-button-search-button') as HTMLButtonElement | null
    button?.focus()
    Callback.call((this.onClick ?? '') as string)
  }

  renderIcon() {
    if (this.preset === 'date-search' || this.preset === 'date-search-mobile') {
      return `<lvc-calendar-icon class="icon" data-width="24" data-height="24"></lvc-calendar-icon>`
    } else if (this.preset === 'region-search' || this.preset === 'region-search-mobile') {
      return `<lvc-location-icon class="icon" data-width="24" data-height="24"></lvc-location-icon>`
    } else {
      return ''
    }
  }

  html = () => {
    let dropdownOrClear = `<button name="dropdown" class="dropdown-button">
    <lvc-chevron-down-icon class="chevron-icon ${this.selected ? 'up' : 'down'}" width="18" height="18"></lvc-chevron-down-icon>
  </button>`
    let clearButton = `<div class="no-clear-button"></div>`

    if (this.count && this.count > 0) {
      dropdownOrClear = `<button name="clear" class="clear-button-search-bar"><lvc-search-cross-icon></lvc-search-cross-icon></button>`
    }

    if (this.count && this.count > 0) {
      clearButton = `<button name="clear" class="clear-button-search-bar"><lvc-search-cross-icon></lvc-search-cross-icon></button>`
    }

    return `
      <div class="wrapper ${this.selected ? 'focused' : ''}">
        <div name="main" class="filter-button ${this.count && this.count > 0 ? 'has-data' : ''}" data-count="${this.count ?? ''}" data-selected="${this.selected ?? ''}">
          
          <button class="filter-button-search-button">
            <div class="filter-button-label" data-count="${this.count ?? ''}">
              <slot></slot>
            </div>
            <div class="filter-button-value ${this.dataValue ? 'has-value' : ''}">
              <div>
                ${
                  this.dataValue
                    ? this.dataValue.length >
                      (window.matchMedia('(max-width: 730px)').matches ? 30 : 10)
                      ? this.dataValue?.substring(
                          0,
                          window.matchMedia('(max-width: 730px)').matches ? 30 : 10
                        ) + '...'
                      : this.dataValue
                    : Locale.getKey('searchFilterButton.selectPlaceholder')
                }
                ${
                  window.matchMedia('(max-width: 730px)').matches
                    ? `
                  <div name="clear" class="clear-button-search-bar inline">
                    <lvc-search-cross-icon></lvc-search-cross-icon>
                  </div>
                `
                    : ''
                }
              </div>
              ${
                window.matchMedia('(max-width: 730px)').matches
                  ? `
                  <button name="dropdown" class="dropdown-button">
                    <lvc-chevron-down-icon class="chevron-icon down" width="18" height="18"></lvc-chevron-down-icon>
                  </button>
                `
                  : dropdownOrClear
              }
            </div>
          </button>
        </div>
      </div>
    `
  }

  css = () => `

      .filter-button {
      position: relative;
      height: 54px;
      display: flex;
      box-sizing: border-box;
      border-radius: 60px;
      gap: 10px;
      padding: ${!this.dataLastChild ? '0 15px 0 30px' : '0 30px'};
      }
      
      ${
        this.selected
          ? `
        .filter-button {
          background: #BFF0FF;
          position: relative;
        }
      `
          : ''
      }
      
      .filter-button-value {
        opacity: .3;
      }
      
      .filter-button-value.has-value {
        opacity: 1;
        font-weight: ${Font.weight.extraBold};
        font-size: 16px;
      }

      .clear-button-search-bar, .dropdown-button {
        padding-top: 20px;
      }
      
      lvc-chevron-down-icon.up {
      transform: rotate(180deg);
      transition: transform 0.2s ease-in-out;
      }
      
      lvc-chevron-down-icon.down {
      transform: rotate(0deg);
      transition: transform 0.2s ease-in-out;
      }

      .no-clear-button{
      height: 36px;
      width: 31.5px;
      margin-right: 5px;
      }

      .clear-button-search-bar {
        height: 100%;
        box-sizing: border-box;
        display: block;
        cursor: pointer;
        font-family: ${Font.family};
        color: var(--brand-minuit, #1E007D);
        text-align: left;
        font-variant-numeric: lining-nums tabular-nums;
        font-feature-settings: 'clig' off, 'liga' off;

        font-size: 14px;
        font-style: normal;
        font-weight: ${Font.weight.medium};
        line-height: 120%; /* 16.8px */
        border: none;
        background: none;
        margin-right: 5px;
      }

      lvc-location-icon{
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      }

      .filter-button-search {
        position: relative;
        height: 54px;
        width: 220px;
        display: flex;
        padding-left: 22px;
        padding-right: 22px;
        align-self: center;
        box-sizing: border-box;
        cursor: pointer;
      }

      .filter-button.selected {
      background: var(--brand-menthe, #DCFFD7);
      border-color: var(--brand-minuit, #1E007D);
      }

      filter-button-search.selected{
      background: var(--brand-menthe, #DCFFD7);
      border-color: var(--brand-minuit, #1E007D);
      }

      .filter-button button {
      width: max-content;
      height: 100%;
      box-sizing: border-box;
      display: block;
      cursor: pointer;
      font-family: ${Font.family};
      color: var(--brand-minuit, #1E007D);
      text-align: left;
      font-variant-numeric: lining-nums tabular-nums;
      font-feature-settings: 'clig' off, 'liga' off;
      font-size: 14px;
      font-style: normal;
      font-weight: ${Font.weight.medium};
      line-height: 120%; /* 16.8px */
      border: none;
      background: none;
      }

      button[name="dropdown"], button[name="clear"] {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.5s ease-in-out;
      }
      
      .filter-button::after {
        ${this.count && this.count > 0 ? `content: attr(data-count);` : ``} 
        text-align: center;
        position: absolute;
        top: -20px;
        right: -5px;
        border-radius: 50px;
        width: 32px;
        height: 32px;
        background: white;
        border: 1px solid var(--brand-minuit, #1E007D);
        color: var(--brand-minuit, #1E007D);
        display: flex;
        align-items: center;
        justify-content: center;
        font-variant-numeric: lining-nums tabular-nums;
        font-feature-settings: 'clig' off, 'liga' off;
        z-index: 1;
      
        /* D/textes/petits textes */
        font-family: ${Font.family};
        font-size: 14px;
        font-style: normal;
        font-weight: ${Font.weight.medium};
        line-height: 35px; /* 16.8px */
      }
      
      .filter-button.selected::after,
      .filter-button-search.selected::after,
      .filter-button-search::after{
        display: none;
      }

      .filter-button-search-button {
      flex: 1 1 1px;
      height: 100%;
      box-sizing: border-box;
      display: block;
      cursor: pointer;
      font-family: ${Font.family};
      color: var(--brand-minuit, #1E007D);
      text-align: left;
      font-variant-numeric: lining-nums tabular-nums;
      font-feature-settings: 'clig' off, 'liga' off;

      font-size: 14px;
      font-style: normal;
      font-weight: ${Font.weight.medium};
      line-height: 120%; /* 16.8px */
      border: none;
      background: none;
      }
      
      .wrapper.focused .filter-button-search-button:before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 50px;
        box-shadow: 0px 0px 10px 0px #0000001A;
      }
      
      ${
        !this.dataFirstChild
          ? `
        .wrapper.focused:before {
          content: "";
          display: block;
          position: absolute;
          height: 35px;
          width: 1px;
          background: #fff;
          top: 0;
          bottom: 0;
          left: -1px;
          margin: auto;
        }
      `
          : ''
      }
      
      ${
        !this.dataLastChild && !this.selected
          ? `
        .wrapper:after {
          content: "";
          display: block;
          position: absolute;
          height: 32px;
          width: 1px;
          background: #1E007D4D;
          top: 0;
          bottom: 0;
          right: 0;
          margin: auto;
        }
      `
          : null
      }

      .filter-button-search-button:focus {
      outline: none;
      }
      
      .filter-button-search::after {
      ${this.count && this.count > 0 ? `content: attr(data-count);` : ''}
      text-align: center;
      position: absolute;
      top: -20px;
      right: 2px;
      border-radius: 50px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      background: var(--brand-minuit, #1E007D);
      color: var(--brand-spotlight, #FF4600);
      font-variant-numeric: lining-nums tabular-nums;
      font-feature-settings: 'clig' off, 'liga' off;

      /* D/textes/petits textes */
      font-family: ${Font.family};
      font-size: 14px;
      font-style: normal;
      font-weight: ${Font.weight.medium};
      line-height: 35px; /* 16.8px */
      transition: transform 0.5s ease-in-out; /* Added transition property */
      }

      lvc-calendar-icon{
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      }
      @media screen and (max-width: 900px) {

        :host {
          display: flex;
        }

        .chevron-icon{
          rotate: -90deg;
        }

        .dropdown-button {
          padding: 0px;
        }

        .wrapper {
          display: flex;
          flex-grow: 1;
          width: 100%;
        }

        .filter-button {
          height: 40px;
          padding: 0px; 
          display: flex;
          justify-content: space-between;
          width: 100%;
        } 

        button[name="dropdown"], button[name="clear"] {
          justify-content: flex-end;
          flex: 0 0 30px;
        }

        .filter-button {
          height: auto;
          padding: 12px 0 10px;
        }
        
        .filter-button.has-data {
          padding-top: 0;
        }

        .filter-button::after {
          display: none;
        }
        .filter-button.selected::after, filter-button-search::after {
          display: none;
        }
        
        .filter-button-label {
          width: fit-content;
          position: relative;
        }
        
        .filter-button-label::after {
          ${this.count && this.count > 0 ? `content: attr(data-count);` : ``} 
          text-align: center;
          position: absolute;
          top: -8px;
          right: -20px;
          border-radius: 50px;
          width: 18px;
          height: 18px;
          background: white;
          border: 0.5px solid var(--brand-minuit, #1E007D);
          color: var(--brand-minuit, #1E007D);
          display: flex;
          align-items: center;
          justify-content: center;
          font-variant-numeric: lining-nums tabular-nums;
          font-feature-settings: 'clig' off, 'liga' off;
          z-index: 1;
          
          /* D/textes/petits textes */
          font-family: ${Font.family};
          font-size: 8px;
          font-style: normal;
          font-weight: ${Font.weight.regular};
          line-height: 1;
        }
        
        .clear-button-search-bar.inline {
          display: inline-block;
          height: auto;
          padding-top: 0;
          margin-left: 10px;
        }
        
        .clear-button-search-bar.inline lvc-search-cross-icon {
          height: 16px;
        }
        
        .filter-button-value > div {
          display: none;
        }
        .filter-button-value.has-value > div {
          display: flex;
        }
      }
    `

  eventListeners: EventListeners = [
    ['[name="main"]', 'click', this.onClickButton.bind(this)],
    ['.icon', 'click', this.onClickButton.bind(this)],
    ['[name="clear"]', 'click', this.onClearButton.bind(this)],
  ]
}
